import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

/**
 * Thin navigation seam around a full-page browser redirect.
 *
 * Wrapping `document.location` (rather than calling `window.location.href`
 * directly inside components) keeps callers unit-testable: specs provide a
 * fake DOCUMENT and assert the target URL without triggering a real
 * navigation.
 */
@Injectable({ providedIn: 'root' })
export class RedirectService {
  private readonly document = inject(DOCUMENT);

  /** Navigate the browser to an absolute, externally-built URL. */
  to(url: string): void {
    this.document.location.href = url;
  }
}
